<div class="notification-container" *ngIf="notification" [@slideIn]>
    <div class="notification-snackbar" [ngClass]="'notification-' + notification.type">
        <span class="material-icons notification-icon">{{ getIcon() }}</span>
        <span class="notification-message">{{ notification.message }}</span>
        <button class="notification-close" (click)="close()">
            <span class="material-icons">close</span>
        </button>
    </div>
</div>
